<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        item-key="none"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-menu
              :absolute="false"
              :close-on-click="true"
              :close-on-content-click="true"
              offset-y
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="ma-2" color="primary">
                ADD
                <v-icon class="ml-2" small>mdi-text-box</v-icon>
              </v-btn>
            </template>
            <v-sheet max-height="600">
              <v-list dense class="pa-0">
                <v-list-item
                    v-for="(kind,i) in sortedKinds"
                    :key="kind+i"
                    dense
                    @click="row_create(kind)"
                >
                  <v-list-item-title v-text="kind.name"/>
                </v-list-item>
              </v-list>
            </v-sheet>
          </v-menu>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-smart-offer-bundle-shop ref="dialog_1"/>
    <r-smart-offer-bundle-firefly ref="dialog_2"/>
    <r-smart-offer-bundle-achievement ref="dialog_3"/>
    <r-smart-offer-bundle-market ref="dialog_4"/>
    <r-smart-offer-bundle-cascade ref="dialog_5"/>
    <r-smart-offer-bundle-treasure ref="dialog_6"/>
    <r-smart-offer-bundle-energy-refill ref="dialog_7"/>
    <r-smart-offer-bundle-progressive ref="dialog_8"/>
    <r-smart-offer-bundle-master-season ref="dialog_9"/>
    <r-smart-offer-bundle-sunken-ruins ref="dialog_10"/>
    <r-smart-offer-bundle-ancient-treasure ref="dialog_11"/>
    <r-smart-offer-bundle-collection ref="dialog_12"/>
    <r-smart-offer-bundle-daily-pass ref="dialog_13"/>
    <r-smart-offer-bundle-decoration ref="dialog_14"/>
    <r-smart-offer-bundle-hidden-temple ref="dialog_15"/>
    <r-smart-offer-bundle-alchemy ref="dialog_16"/>
    <r-smart-offer-bundle-time-limited ref="dialog_17"/>
    <r-smart-offer-bundle-any-purchase ref="dialog_18"/>
    <r-smart-offer-bundle-multi-tab ref="dialog_19"/>
    <r-smart-offer-bundle-treasure-achievement ref="dialog_20"/>
    <r-smart-offer-bundle-plinko ref="dialog_21"/>
    <r-smart-offer-bundle-magic-spin ref="dialog_22"/>
    <r-smart-offer-bundle-treasure-shop ref="dialog_23"/>
    <r-smart-offer-bundle-treasure-offer ref="dialog_24"/>
    <r-smart-offer-bundle-plinko-shop-simple ref="dialog_25"/>
    <r-smart-offer-bundle-plinko-shop-double ref="dialog_26"/>
    <r-smart-offer-bundle-one-plus-two ref="dialog_27"/>
    <r-smart-offer-bundle-card-box-bank ref="dialog_28"/>
    <r-smart-offer-bundle-expd-treasure-gate ref="dialog_29"/>
    <r-smart-offer-bundle-expd-treasure-tree ref="dialog_30"/>
    <r-smart-offer-bundle-novice-battle-pass ref="dialog_31"/>
    <r-smart-offer-bundle-piggy ref="dialog_32"/>
    <r-smart-offer-bundle-reward-giver ref="dialog_33"/>
    <r-smart-offer-bundle-christmas-hub ref="dialog_34"/>
    <r-smart-offer-bundle-christmas-calendar ref="dialog_35"/>
    <r-smart-offer-bundle-christmas ref="dialog_36"/>
    <r-smart-offer-bundle-expedition-group ref="dialog_37"/>
    <r-smart-offer-bundle-flash-ad ref="dialog_38"/>
    <r-smart-offer-bundle-magical-cinema ref="dialog_39"/>
    <r-smart-offer-bundle-hub ref="dialog_40"/>
  </div>
</template>

<script>

import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {SmartOfferBundle} from "@/modules/redactor/models/smart-offer/bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "@/modules/redactor/models/smart-offer/bundle-core/SmartOfferBundleKind";

import RSmartOfferBundleShop from "@/modules/redactor/views/smart-offer/bundle-shop/r-smart-offer-bundle-shop.vue";
import RSmartOfferBundleFirefly from "@/modules/redactor/views/smart-offer/bundle-firefly/r-smart-offer-bundle-firefly.vue";
import RSmartOfferBundleAchievement from "@/modules/redactor/views/smart-offer/bundle-achievement/r-smart-offer-bundle-achievement.vue";
import RSmartOfferBundleMarket from "@/modules/redactor/views/smart-offer/bundle-market/r-smart-offer-bundle-market.vue";
import RSmartOfferBundleCascade from "@/modules/redactor/views/smart-offer/bundle-cascade/r-smart-offer-bundle-cascade.vue";
import RSmartOfferBundleTreasure from "@/modules/redactor/views/smart-offer/bundle-treasure/r-smart-offer-bundle-treasure.vue";
import RSmartOfferBundleProgressive from "@/modules/redactor/views/smart-offer/bundle-progressive/r-smart-offer-bundle-progressive.vue";
import RSmartOfferBundleMasterSeason from "@/modules/redactor/views/smart-offer/bundle-master-season/r-smart-offer-bundle-master-season.vue";
import RSmartOfferBundleSunkenRuins from "@/modules/redactor/views/smart-offer/bundle-sunken-ruins/r-smart-offer-bundle-sunken-ruins.vue";
import RSmartOfferBundleAncientTreasure from "@/modules/redactor/views/smart-offer/bundle-ancient-treasure/r-smart-offer-bundle-ancient-treasure";
import RSmartOfferBundleCollection from "@/modules/redactor/views/smart-offer/bundle-collection/r-smart-offer-bundle-collection.vue";
import RSmartOfferBundleDailyPass from "@/modules/redactor/views/smart-offer/bundle-daily-pass/r-smart-offer-bundle-daily-pass.vue";
import RSmartOfferBundleDecoration from "@/modules/redactor/views/smart-offer/bundle-decoration/r-smart-offer-bundle-decoration";
import RSmartOfferBundleHiddenTemple from "@/modules/redactor/views/smart-offer/bundle-hidden-temple/r-smart-offer-bundle-hidden-temple.vue";
import RSmartOfferBundleAlchemy from "@/modules/redactor/views/smart-offer/bundle-alchemy/r-smart-offer-bundle-alchemy.vue";
import RSmartOfferBundleTimeLimited from "@/modules/redactor/views/smart-offer/bundle-time-limited/r-smart-offer-bundle-time-limited.vue";
import RSmartOfferBundleAnyPurchase from "@/modules/redactor/views/smart-offer/bundle-any-purchase/r-smart-offer-bundle-any-purchase.vue";
import RSmartOfferBundleMultiTab from "@/modules/redactor/views/smart-offer/bundle-multi-tab/r-smart-offer-bundle-multi-tab.vue";
import RSmartOfferBundleTreasureAchievement from "@/modules/redactor/views/smart-offer/bundle-treasure-achievement/r-smart-offer-bundle-treasure-achievement.vue";
import RSmartOfferBundlePlinko from "@/modules/redactor/views/smart-offer/bundle-plinko/r-smart-offer-bundle-plinko.vue";
import RSmartOfferBundleMagicSpin from "@/modules/redactor/views/smart-offer/bundle-magic-spin/r-smart-offer-bundle-magic-spin";
import RSmartOfferBundleTreasureOffer from "@/modules/redactor/views/smart-offer/bundle-treasure-offer/r-smart-offer-bundle-treasure-offer";
import RSmartOfferBundleTreasureShop from "@/modules/redactor/views/smart-offer/bundle-treasure-shop/r-smart-offer-bundle-treasure-shop";
import RSmartOfferBundlePlinkoShopSimple from "@/modules/redactor/views/smart-offer/bundle-plinko-shop/r-smart-offer-bundle-plinko-shop-simple.vue";
import RSmartOfferBundlePlinkoShopDouble from "@/modules/redactor/views/smart-offer/bundle-plinko-shop/r-smart-offer-bundle-plinko-shop-double.vue";
import RSmartOfferBundleOnePlusTwo from "@/modules/redactor/views/smart-offer/bundle-one-plus-two/r-smart-offer-bundle-one-plus-two.vue";
import RSmartOfferBundleCardBoxBank from "@/modules/redactor/views/smart-offer/bundle-card-box-bank/r-smart-offer-bundle-card-box-bank.vue";
import RSmartOfferBundleExpdTreasureGate from "@/modules/redactor/views/smart-offer/bundle-expedition-treasure/r-smart-offer-bundle-expd-treasure-gate.vue";
import RSmartOfferBundleExpdTreasureTree from "@/modules/redactor/views/smart-offer/bundle-expedition-treasure/r-smart-offer-bundle-expd-treasure-tree.vue";
import RSmartOfferBundleNoviceBattlePass from "@/modules/redactor/views/smart-offer/bundle-novice-battle-pass/r-smart-offer-bundle-novice-battle-pass";
import RSmartOfferBundlePiggy from "@/modules/redactor/views/smart-offer/bundle-piggy/r-smart-offer-bundle-piggy.vue";
import RSmartOfferBundleRewardGiver from "@/modules/redactor/views/smart-offer/bundle-reward-giver/r-smart-offer-bundle-reward-giver.vue";
import RSmartOfferBundleChristmasHub from "@/modules/redactor/views/smart-offer/bundle-christmas-hub/r-smart-offer-bundle-christmas-hub.vue";
import RSmartOfferBundleChristmasCalendar from "@/modules/redactor/views/smart-offer/bundle-christmas-calendar/r-smart-offer-bundle-christmas-calendar";
import RSmartOfferBundleChristmas from "@/modules/redactor/views/smart-offer/bundle-christmas/r-smart-offer-bundle-christmas.vue";
import RSmartOfferBundleExpeditionGroup from "@/modules/redactor/views/smart-offer/bundle-expedition-group/r-smart-offer-bundle-expedition-group.vue";
import RSmartOfferBundleEnergyRefill from "@/modules/redactor/views/smart-offer/bundle-energy-refill/r-smart-offer-bundle-energy-refill.vue";
import RSmartOfferBundleFlashAd from "@/modules/redactor/views/smart-offer/bundle-flash-ad/r-smart-offer-bundle-flash-ad.vue";
import RSmartOfferBundleMagicalCinema from "@/modules/redactor/views/smart-offer/bundle-magical-cinema/r-smart-offer-bundle-magical-cinema.vue";
import RSmartOfferBundleHub from "@/modules/redactor/views/smart-offer/bundle-hub/r-smart-offer-bundle-hub.vue";

export default {
  name: "r-smart-offer-bundle-table",
  components: {
    RSmartOfferBundleMagicalCinema,
    RSmartOfferBundleFlashAd,
    RSmartOfferBundleChristmasCalendar,
    RSmartOfferBundlePiggy,
    RSmartOfferBundlePlinkoShopDouble,
    RSmartOfferBundlePlinkoShopSimple,
    RSmartOfferBundleTreasureShop,
    RSmartOfferBundleTreasureOffer,
    RSmartOfferBundleMagicSpin,
    RSmartOfferBundlePlinko,
    RSmartOfferBundleTreasureAchievement,
    RSmartOfferBundleMultiTab,
    RSmartOfferBundleAnyPurchase,
    RSmartOfferBundleDecoration,
    RSmartOfferBundleDailyPass,
    RSmartOfferBundleCollection,
    RSmartOfferBundleMasterSeason,
    RSmartOfferBundleSunkenRuins,
    RSmartOfferBundleAncientTreasure,
    RSmartOfferBundleTreasure,
    RSmartOfferBundleProgressive,
    RSmartOfferBundleCascade,
    RSmartOfferBundleMarket,
    RSmartOfferBundleShop,
    RSmartOfferBundleAchievement,
    RSmartOfferBundleFirefly,
    RSmartOfferBundleHiddenTemple,
    RSmartOfferBundleAlchemy,
    RSmartOfferBundleTimeLimited,
    RSmartOfferBundleOnePlusTwo,
    RSmartOfferBundleCardBoxBank,
    RSmartOfferBundleExpdTreasureGate,
    RSmartOfferBundleExpdTreasureTree,
    RSmartOfferBundleNoviceBattlePass,
    RSmartOfferBundleRewardGiver,
    RSmartOfferBundleChristmasHub,
    RSmartOfferBundleChristmas,
    RSmartOfferBundleExpeditionGroup,
    RSmartOfferBundleEnergyRefill,
    RSmartOfferBundleHub
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'name'},
      {text: 'Kind', value: 'kind.name'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(SmartOfferBundle),
  },
  computed: {
    empty() {
      return this.items.length === 0;
    },
    kinds() {
      console.log(SmartOfferBundleKind.getValues());
      return SmartOfferBundleKind.getValues();
    },
    sortedKinds() {
      return [...this.kinds].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    }
  },
  methods: {
    row_copy(item) {
      this.$refs['dialog_' + item.kind.id].show(ViewRules.COPY, item.copy())
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_create(kind) {
      console.log(this.$refs);
      this.$refs['dialog_' + kind.id].show(ViewRules.CREATE, null)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog_' + item.kind.id].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    }
  }
}

</script>
